/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TableFooter
} from 'material-ui/Table'
import { Checkbox, FlatButton, FontIcon, CircularProgress, RaisedButton } from 'material-ui'
import { green500 } from 'material-ui/styles/colors'
import { TextField } from 'generic/form'

import * as applicantActions from 'actions/Applicant'
import * as applicationConstants from 'constants/Applicant'

class ApplicantList extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      applicants: [],
      page: 1,
      totalElements: 0,
      totalPages: 0,
      pageSize: 0,
      loading: false,
      search: undefined,
      filterAbaCode: undefined,
      sortTable: 'entities__name',
      applicant: undefined,
    }

    this.handleChangeSearch = this.handleChangeSearch.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleApplicant = this.handleApplicant.bind(this)
  }

  componentDidMount() {
    this.handleLoadApplicants({sort: 'entities__name'})

    applicantActions.getApplicant()
      .then((result) => {
        this.setState({
          applicant: result
        })
      })
  }

  handleLoadApplicants(query) {
    this.setState({
      loading: true
    })

    query = {
      ...query,
      page_size: 12,
      from_abacus: false,
    }

    applicantActions.getApplicants(query)
      .then((result) => {
        this.setState({
          totalElements: result.total_elements,
          totalPages: result.total_pages,
          pageSize: result.page_size,
          applicants: result.objects
        })

        this.props.handleChange('rightIcon', result.total_elements + ' ' + this.props.intl.formatMessage(applicationConstants.messages.TOTAL_ELEMENTS))
      })
      .finally(() => {
        this.setState({
          loading: false
        })
      })
  }

  handlePagination(page) {
    this.setState({
      page: page
    })

    const query = {
      aba_code: this.state.filterAbaCode,
      search: this.state.search,
      sort: this.state.sortTable,
      page: page,
    }

    this.handleLoadApplicants(query)
  }

  handleChangeSearch(event, value) {
    let search
    let filterAbaCode

    if(Number(value)) {
      filterAbaCode = Number(value)
    } else if (value) {
      search = 'name:' + value
    }

    this.setState({
      filterAbaCode: filterAbaCode,
      search: search,
      page: 1
    })
  }

  handleSearch() {
    const query = {
      aba_code: this.state.filterAbaCode,
      search: this.state.search,
      page: this.state.page,
      sort: this.state.sortTable,
    }

    this.handleLoadApplicants(query)
  }

  handleKeyDown(event) {
    if(event.keyCode === 13){
      this.handleSearch()
    }
  }

  handleSort(column) {
    const currentColumn = this.state.sortTable && this.state.sortTable.replace('-', '')

    if (column === currentColumn) {
      column = '-'+column
    }

    if (column === this.state.sortTable) {
      column = this.state.sortTable.replace('-', '')
    }

    this.setState({
      sortTable: column,
      page: 1
    })

    const query = {
      aba_code: this.state.filterAbaCode,
      search: this.state.search,
      page: 1,
      sort: column,
    }

    this.handleLoadApplicants(query)
  }

  handleApplicant(value) {
    this.props.handleChange('rightIcon', undefined)

    this.props.handleChange('applicant', value || this.state.applicant)
  }

  render () {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-md-offset-3 col-md-5 col-xs-12'>
            <TextField
              name='searchText'
              floatingLabelText={this.props.intl.formatMessage(applicationConstants.messages.SEARCH)}
              placeholder={this.props.intl.formatMessage(applicationConstants.messages.SEARCH_PLACEHOLDER)}
              onChange={this.handleChangeSearch}
              onKeyDown={this.handleKeyDown}
            />
          </div>

          <div className='col-md-2 col-xs-6'>
            <RaisedButton
              label={this.props.intl.formatMessage(applicationConstants.messages.SEARCH)}
              primary={true}
              onClick={this.handleSearch}
              icon={<FontIcon className='material-icons'>search</FontIcon>}
              style={styles.button}
              buttonStyle={styles.buttonStyle}
            />
          </div>

          <div className='col-md-2 col-xs-6'>
            <RaisedButton
              label={this.props.intl.formatMessage(applicationConstants.messages.ADD_APPLICANT)}
              onClick={() => this.handleApplicant()}
              icon={<FontIcon className='material-icons'>add</FontIcon>}
              style={styles.button}
              buttonStyle={styles.buttonStyle}
              backgroundColor={green500}
              labelColor="white"
            />
          </div>
        </div>

        <Table
          style={
            this.state.loading ||
            !this.state.applicants.length
              ? {overflow: 'hidden'}
              : undefined
          }
        >
          <TableHeader
            displaySelectAll={false}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn
                colSpan="2"
              >
                <span
                  onClick={() => this.handleSort('entities__name')}
                  style={styles.rowCursor}
                >
                  {this.props.intl.formatMessage(applicationConstants.messages.ENTITY_NAME_LABEL)}

                  {
                    this.state.sortTable === 'entities__name'
                      ? <FontIcon
                        className='material-icons'
                        style={styles.sortingIcon}
                      >
                        arrow_upward
                      </FontIcon>
                      : this.state.sortTable === '-entities__name'
                        ? <FontIcon
                          className='material-icons'
                          style={styles.sortingIcon}
                        >
                          arrow_downward
                        </FontIcon>
                      : undefined
                  }
                </span>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <span
                  onClick={() => this.handleSort('identities__first_name')}
                  style={styles.rowCursor}
                >
                  {this.props.intl.formatMessage(applicationConstants.messages.IDENTITY_NAME_LABEL)}

                  {
                    this.state.sortTable === 'identities__first_name'
                      ? <FontIcon
                        className='material-icons'
                        style={styles.sortingIcon}
                      >
                        arrow_upward
                      </FontIcon>
                      : this.state.sortTable === '-identities__first_name'
                        ? <FontIcon
                          className='material-icons'
                          style={styles.sortingIcon}
                        >
                          arrow_downward
                        </FontIcon>
                      : undefined
                  }
                </span>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <span
                  onClick={() => this.handleSort('users__username')}
                  style={styles.rowCursor}
                >
                  {this.props.intl.formatMessage(applicationConstants.messages.USERNAME_LABEL)}

                  {
                    this.state.sortTable === 'users__username'
                      ? <FontIcon
                        className='material-icons'
                        style={styles.sortingIcon}
                      >
                        arrow_upward
                      </FontIcon>
                      : this.state.sortTable === '-users__username'
                        ? <FontIcon
                          className='material-icons'
                          style={styles.sortingIcon}
                        >
                          arrow_downward
                        </FontIcon>
                      : undefined
                  }
                </span>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <span
                  onClick={() => this.handleSort('aba_code')}
                  style={styles.rowCursor}
                >
                  {this.props.intl.formatMessage(applicationConstants.messages.APPLICANT_ABA_CODE_LABEL)}

                  {
                    this.state.sortTable === 'aba_code'
                      ? <FontIcon
                        className='material-icons'
                        style={styles.sortingIcon}
                      >
                        arrow_upward
                      </FontIcon>
                      : this.state.sortTable === '-aba_code'
                        ? <FontIcon
                          className='material-icons'
                          style={styles.sortingIcon}
                        >
                          arrow_downward
                        </FontIcon>
                      : undefined
                  }
                </span>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <span
                  onClick={() => this.handleSort('is_active')}
                  style={styles.rowCursor}
                >
                  {this.props.intl.formatMessage(applicationConstants.messages.APPLICANT_IS_ACTIVE_LABEL)}

                  {
                    this.state.sortTable === 'is_active'
                      ? <FontIcon
                        className='material-icons'
                        style={styles.sortingIcon}
                      >
                        arrow_upward
                      </FontIcon>
                      : this.state.sortTable === '-is_active'
                        ? <FontIcon
                          className='material-icons'
                          style={styles.sortingIcon}
                        >
                          arrow_downward
                        </FontIcon>
                      : undefined
                  }
                </span>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <span
                  onClick={() => this.handleSort('users__last_login')}
                  style={styles.rowCursor}
                >
                  {this.props.intl.formatMessage(applicationConstants.messages.USER_LAST_LOGIN_LABEL)}

                  {
                    this.state.sortTable === 'users__last_login'
                      ? <FontIcon
                        className='material-icons'
                        style={styles.sortingIcon}
                      >
                        arrow_upward
                      </FontIcon>
                      : this.state.sortTable === '-users__last_login'
                        ? <FontIcon
                          className='material-icons'
                          style={styles.sortingIcon}
                        >
                          arrow_downward
                        </FontIcon>
                      : undefined
                  }
                </span>
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>

          <TableBody
            displayRowCheckbox={false}
          >
            {
              this.state.loading
                ? <TableRow>
                  <CircularProgress
                    size={50}
                    thickness={2}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  />
                </TableRow>
                : <React.Fragment>
                  {
                    this.state.applicants.map((applicant) => {
                      return (
                        <TableRow
                          style={{cursor: 'pointer'}}
                          onClick={() => this.handleApplicant(applicant)}
                        >
                          <TableRowColumn
                            colSpan="2"
                          >
                            {
                              applicant.entities.map((entity) => {
                                return (
                                  <React.Fragment>
                                    {entity.name}
                                    <br/>
                                  </React.Fragment>
                                )
                              })
                            }
                          </TableRowColumn>
                          <TableRowColumn>
                            {
                              applicant.identities.map((identity) => {
                                return (
                                  <React.Fragment>
                                    {identity.first_name} {identity.last_name}
                                    <br/>
                                  </React.Fragment>
                                )
                              })
                            }
                          </TableRowColumn>
                          <TableRowColumn>
                            {
                              applicant.users.map((user) => {
                                return (
                                  <React.Fragment>
                                    {user.username}
                                    <br/>
                                  </React.Fragment>
                                )
                              })
                            }
                          </TableRowColumn>
                          <TableRowColumn>
                            {applicant.aba_code}
                          </TableRowColumn>
                          <TableRowColumn>
                            <Checkbox
                              checked={applicant.is_active}
                              disabled={true}
                            />
                          </TableRowColumn>
                          <TableRowColumn>
                            {
                              applicant.users.map((user) => {
                                return (
                                  <React.Fragment>
                                    {
                                      user.last_login
                                        ? moment(user.last_login, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm')
                                        : undefined
                                    }
                                    <br/>
                                  </React.Fragment>
                                )
                              })
                            }
                          </TableRowColumn>
                        </TableRow>
                      )
                    })
                  }
                </React.Fragment>
            }
          </TableBody>

          {
            !this.state.loading &&
            this.state.applicants.length
              ? <TableFooter
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <div className='col-md-2 col-md-offset-10 col-xs-12' style={{marginTop: 15}}>
                      <FlatButton
                        secondary={true}
                        disabled={this.state.page === 1}
                        icon={<FontIcon className='material-icons'>keyboard_arrow_left</FontIcon>}
                        onClick={() => this.handlePagination(this.state.page - 1)}
                      />
                      <span>{this.state.page} / {this.state.totalPages}</span>
                      <FlatButton
                        secondary={true}
                        disabled={this.state.page === this.state.totalPages}
                        icon={<FontIcon className='material-icons'>keyboard_arrow_right</FontIcon>}
                        onClick={() => this.handlePagination(this.state.page + 1)}
                      />
                    </div>
                  </TableRow>
                </TableFooter>
              : undefined
          }
        </Table>
      </React.Fragment>
    )
  }
}

const styles = {
  sortingIcon: {
    fontSize: 15,
    marginLeft: 15,
  },
  rowCursor: {
    cursor: 'pointer',
  },
  button: {
    minWidth: 125,
    marginTop: '10%',
    height: 'auto',
    overflow: 'visible',
  },
  buttonStyle: {
    minHeight: 36,
  },
}

export default injectIntl(ApplicantList)



// WEBPACK FOOTER //
// ./src/components/staff/ApplicantList.js